/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedPeopleMultiple200,
  GetApiV1CourseregistrationSharedPeopleMultiple401,
  GetApiV1CourseregistrationSharedPeopleMultiple500,
  GetApiV1CourseregistrationSharedPeopleMultipleQueryParams,
  GetApiV1CourseregistrationSharedPeopleMultipleQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedPeopleMultiple.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";
import { ePersonTypeSchema } from "../ePersonTypeSchema.ts";

export const getApiV1CourseregistrationSharedPeopleMultipleQueryParamsSchema =
  z.object({
    filter: z.optional(z.string()),
    type: z.optional(
      z
        .lazy(() => ePersonTypeSchema)
        .describe(
          "1 = Employee | 2 = Teaching | 3 = Student | 4 = Monitor | 5 = Seller | 6 = Advisor | 7 = SellerManager | 8 = Coordinator | ",
        ),
    ),
    companyId: z.optional(z.coerce.number().int()),
    activeOnly: z.boolean().default(false),
  }) as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleMultipleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedPeopleMultiple200Schema = z.array(
  z.lazy(() => dropDownListStringKeyViewModelSchema),
) as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleMultiple200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedPeopleMultiple401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleMultiple401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedPeopleMultiple500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleMultiple500>;

export const getApiV1CourseregistrationSharedPeopleMultipleQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedPeopleMultiple200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleMultipleQueryResponse>;
